import React, { Component } from "react";
import { connect } from "react-redux";
import {UsertourAction,getSelectedTab, handleMobileDraw} from "../../../action/index.js";
import * as cuComponent from "../../../redux/reducers/building_component/componentReducer.js";

import Tour from 'reactour';
class UserTour extends Component { 

  constructor(props) {
    super(props); 

    this.state = {
      isDevice: false,
      isSmallScreen: false,
    };
  }


   closeTour = ()=>{
      this.props.UsertourAction(false,'','');
      this.props.handleMobileDraw(false);
   }

currentStepget = (curr)=> {
      this.props.UsertourAction(true,curr,'');
}


checkInnerwidth = ()=> {
   if(window.innerWidth<=1000) {
    this.setState({isDevice:true})
   }
   else {
    this.setState({isDevice:false})

   }

  if(window.innerWidth>1023) {
    this.setState({isSmallScreen:true})
   }
   else {
    this.setState({isSmallScreen:false})
   }
   
}


clickthumb = (key)=>{
  if(key=='gothumbpreview'){
      this.props.handleMobileDraw(true);
      setTimeout(()=>{        
        document.querySelector('.clickforthumbpreview').click();
      },500)
  }
}

      componentDidMount() {    
        this.checkInnerwidth()
         window.addEventListener('resize', () => { 
             if(window.innerWidth>767 && window.innerWidth<=1366) {
                 this.props.UsertourAction(false,'','');
             }
       
             this.checkInnerwidth()
          });

      }


  handlePrevStep = ()=>{

  }

handleNextStep = ()=>{
     
  
}


clickForSaveCompare = ()=> {
  this.props.getSelectedTab("buildsizes");
  const checkopenpanel = document.querySelector('.active-left-panel');
  if(checkopenpanel!=null) {
  document.querySelector('.gosavecompare').click();
  }

  else {
 document.querySelector('#openleftpanel').click();
 setTimeout(()=>{
  document.querySelector('.gosavecompare').click();

},1200)


  }


}

   
  render() {
    const isLogin = this.props.const_var.loginSession;
    let isCompareExsist = true
    if(!this.props.const_var.loginSession && this.props.const_var.stateManufacturerAcordingAPI && this.props.const_var.stateManufacturerAcordingAPI.length > 0 && this.props.params.p_s_n){
        isCompareExsist=this.props.const_var.stateManufacturerAcordingAPI[this.props.params.p_s_n].price_comparision != undefined && this.props.const_var.stateManufacturerAcordingAPI[this.props.params.p_s_n].price_comparision.length > 0 ? true : false
    }
   
    if(this.props.const_var.loginSession && this.props.params.p_s_n && this.props.const_var.stateManufacturerAcordingAPI && this.props.const_var.stateManufacturerAcordingAPI[this.props.params.p_s_n] != undefined && this.props.const_var.stateManufacturerAcordingAPI[this.props.params.p_s_n].length < 2) {
        isCompareExsist = false
    }
   
    const hideCompareOption = this.props.const_var.hideCompareOption && !isLogin;
   
    const isCustomBuilding = this.props?.const_var?.b_o_J_1[this.props?.params?.p_b_t] == "Custom Buildings" && !isLogin; 
    const { isOpenUserTour } = this.props.const_var;
    const { currentStepTour } = this.props.const_var;
    const { startTourNumber } = this.props.const_var;
    let forBig = window.innerWidth > 1050 ? true : false
    let desktoptourConfig = this.props.const_var.crmSetting != undefined && this.props.const_var.crmSetting.is_show_cta != false 
    ? (
        this.props.const_var.loginSession == true
        ?
        [
          {
            selector: '[data-tut="configoptions"]',
            content: ({ goTo }) => (
              <div className="tour-inner right-inner">
                <div class="bubble-container configoptions-bubble">
                  <div class="circle delay1"></div>
                  <div class="circle delay2"></div>
                  <div class="circle delay3"></div>
                  <div class="circle delay4"></div>
                </div>
                <div className="tour-top">
                  <h6>Configuration Panel</h6>
                  {this.props.const_var.loginSession === true ? (
                    <p>Choose building style, size, colors, doors & windows, lean-tos, snow ratings and everything that’s practically possible. </p>
                  ) : (
                    <p>Choose building style, size, colors, doors & windows, lean-tos, snow ratings and everything that’s practically possible. </p>
                  )}
                </div>
                <div className="tourfooter">
                  <div className="tour-count-present">{currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                  <div className="tour-next">
                    <a onClick={this.closeTour} className="skipaction">Skip</a>
                    <a className="nextaction  btn btn-primary btn-xs" onClick={() => goTo(this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 1:currentStepTour)}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
                  </div>
                </div>
              </div>
            ),
          },
          
          {selector: '[data-tut="buildingcontrollerdesktop"]',
              content: ({ goTo }) => (
              <div className="tour-inner left-inner">
                <div class="bubble-container buildingcontroller-bubble">
              <div class="circle delay1"></div>
              <div class="circle delay2"></div>
              <div class="circle delay3"></div>
              <div class="circle delay4"></div>
            </div>      
              <div className="tour-top">
              <h6>Controls</h6>
              {
                this.props.const_var.loginSession == true
                ?
                  <p>View Frame only, Center align doors & windows, zoom in & out, rotate the building, check measurements etc.</p>
                :
                  <p>View Frame only, Center align doors & windows, zoom in & out, rotate the building, check measurements etc.</p>
                }
              </div>       
                <div className="tourfooter">
                  <div className="tour-count-present">{this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"?2:currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                  <div className="tour-next">
                    <a onClick={this.closeTour} className="skipaction">Skip</a>
                    <a className="nextaction btn btn-primary btn-xs" onClick={() => goTo(this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 3:currentStepTour)}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
                  </div>
                </div>
              </div>
            )
            },
    
            this.state.isSmallScreen == true && this.props.const_var.crmSetting.is_module_name!="inventory" && {
              selector: '[data-tut="twoddrawing"]',
              content: ({ goTo }) => (
                <div className="tour-inner bottom-inner">
                  <div className="bubble-container twoddrawing-bubble" style={{'left':`${this.props.const_var.crmSetting.is_loggedin==false ? '160px':''}`}}>
                    <div className="circle delay1"></div>
                    <div className="circle delay2"></div>
                    <div className="circle delay3"></div>
                    <div className="circle delay4"></div>
                  </div>
                  <div className="tour-top">
                    <h6>2D Layout</h6>
                    <p>Generate and preview the 2D layout of your custom-designed building.</p>
                  </div>
                  <div className="tourfooter">
                    <div className="tour-count-present">{currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                    <div className="tour-next">
                      <a onClick={this.closeTour} className="skipaction">Skip</a>
                      <a className="nextaction btn btn-primary btn-xs" onClick={() => { goTo(currentStepTour); }}>
                        <span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span>
                      </a>
                    </div>
                  </div>
                </div>
              ),
              position: "bottom",
            },
    
            {selector: '[data-tut="headpaneloption"]',
              content: ({ goTo }) => (
              <div className="tour-inner left-inner">
                <div class="bubble-container headpaneloption-bubble">
              <div class="circle delay1"></div>
              <div class="circle delay2"></div>
              <div class="circle delay3"></div>
              <div class="circle delay4"></div>
            </div>      
              <div className="tour-top">
              <h6> { this.props.const_var.loginSession == true ? 'Head Panel' : 'State & Price Summary'} </h6>
                { this.props.const_var.loginSession == true ? 
    
                <>
                  <p className={this.props.const_var.crmSetting.is_module_name!="inventory"?'d-none':''}>Locate the Selected State, Manufacturer, Building Size and Price Summary for Inventory.</p>
                <p className={this.props.const_var.crmSetting.is_module_name=="inventory"?'d-none':''}>View or modify selected State, Manufacturer, Building price (with summary) and the lead/customer</p>
                </>
                :
                  <p>Locate Selected State, Price Summary/Contact details for Quote </p>
              }
              
              </div>       
                <div className="tourfooter">
                  <div className="tour-count-present">{this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"?3:currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                  <div className="tour-next">
                    <a onClick={this.closeTour} className="skipaction">Skip</a>
                    {
                      this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"
                      ?
                      <a className="nextaction btn btn-primary btn-xs" onClick={() => goTo(this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 5 :currentStepTour)}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
                      :
                      <a className="nextaction btn btn-primary btn-xs" onClick={() => this.clickForSaveCompare()}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
                    }
                    <a style={{'position':'absolute','opacity':'0'}} className="nextaction btn btn-primary btn-xs gosavecompare" onClick={() => goTo(currentStepTour)}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
                  </div>
                </div>
              </div>
            ),
              position: "bottom",
    
            },
    
    
            this.state.isSmallScreen == true && this.props.const_var.crmSetting.is_module_name!="inventory" && {
              selector: '[data-tut="compare-data-tut"]',
              content: ({ goTo }) => (
                <div className="tour-inner bottom-inner">
                  <div className="bubble-container compare-data-tut-bubble" style={{'left':`${this.props.const_var.crmSetting.is_loggedin==false ? '160px':''}`}}>
                    <div className="circle delay1"></div>
                    <div className="circle delay2"></div>
                    <div className="circle delay3"></div>
                    <div className="circle delay4"></div>
                  </div>
                  <div className="tour-top">
                    <h6>Compare</h6>
                    {isCompareExsist && !hideCompareOption && !isCustomBuilding && !this.props.const_var.checkmoreCustomizeFlag 
                      ?
                      <p> Compare your building designs with other providers to get the best deal. </p>
                      :
                      <p> The compare feature is not provided by this manufacturer. Please contact a salesperson. </p>
                    }
                  </div>
                  <div className="tourfooter">
                    <div className="tour-count-present">{currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                    <div className="tour-next">
                      <a onClick={this.closeTour} className="skipaction">Skip</a>
                      <a className="nextaction btn btn-primary btn-xs" onClick={() => { goTo(currentStepTour); }}>
                        <span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span>
                      </a>
                    </div>
                  </div>
                </div>
              ),
              position: "bottom",
            } ,
            {
              selector: '[data-tut="screen-share-data-tut"]',
              content: ({ goTo }) => (
                <div className="tour-inner bottom-inner">
                  <div className="bubble-container compare-data-tut-bubble" style={{'left':`${this.props.const_var.crmSetting.is_loggedin==false ? '160px':''}`}}>
                    <div className="circle delay1"></div>
                    <div className="circle delay2"></div>
                    <div className="circle delay3"></div>
                    <div className="circle delay4"></div>
                  </div>
                  <div className="tour-top">
                    <h6>Share Screen</h6>
                    <p>Share your screen with others to collaborate and finalize designs together.</p>
                  </div>
                  <div className="tourfooter">
                    <div className="tour-count-present">{currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                    <div className="tour-next">
                      <a onClick={this.closeTour} className="skipaction">Skip</a>
                      <a className="nextaction btn btn-primary btn-xs" onClick={() => { goTo(currentStepTour); }}>
                        <span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span>
                      </a>
                    </div>
                  </div>
                </div>
              ),
              position: "bottom",
              id:"screen-share"
            } ,
    
            {selector: '[data-tut="leftpanelfooter"]',
              content: ({ goTo }) => (
              <div className="tour-inner left-inner">
                <div class='bubble-container leftpanelfooter-bubble'>
              <div class="circle delay1"></div>
              <div class="circle delay2"></div>
              <div class="circle delay3"></div>
              <div class="circle delay4"></div>
            </div>      
              <div className="tour-top">
    
              { this.props.const_var.user_type_for_comparision!="premium" && this.props.const_var.loginSession == true ? <>
    
                <h6>Save</h6>
                <p>Save design to create an order</p>
              </> : 
              <>
              <h6 className={this.props.const_var.crmSetting.is_module_name=="inventory"?'d-none':''}>Save and Share</h6>       
              <h6 className={this.props.const_var.crmSetting.is_module_name!="inventory"?'d-none':''}>Save</h6>       
                  { this.props.const_var.loginSession == true ? 
                  <>
                  <p className={this.props.const_var.crmSetting.is_module_name!="inventory"?'d-none':''}>Save design to create inventory</p>
                  <p className={this.props.const_var.crmSetting.is_module_name=="inventory"?'d-none':''}>Save design to order or compare prices across multiple manufacturers</p>
                  </>
                  :
                  <p>Save your building design to place an order and share it for final decision making.</p>
    
                }</> }
    
              
              </div>       
                <div className="tourfooter">
                  <div className="tour-count-present">{this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"?4:currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                  <div className="tour-next">
              
                    <a className="nextaction  btn btn-primary btn-xs" onClick={()=> {this.closeTour();this.props.getSelectedTab("buildingtypetab")}}><span className="text"></span>Done</a>
    
                  </div>
                </div>
              </div>
            ),
              position: "top",
    
            },
          ] 
        :
        [
          {
            selector: '[data-tut="configoptions"]',
            content: ({ goTo }) => (
              <div className="tour-inner right-inner">
                <div class="bubble-container configoptions-bubble">
                  <div class="circle delay1"></div>
                  <div class="circle delay2"></div>
                  <div class="circle delay3"></div>
                  <div class="circle delay4"></div>
                </div>
                <div className="tour-top">
                  <h6>Configuration Panel</h6>
                  {this.props.const_var.loginSession === true ? (
                    <p>Choose building style, size, colors, doors & windows, lean-tos, snow ratings and everything that’s practically possible. </p>
                  ) : (
                    <p>Choose building style, size, colors, doors & windows, lean-tos, snow ratings and everything that’s practically possible. </p>
                  )}
                </div>
                <div className="tourfooter">
                  <div className="tour-count-present">{currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                  <div className="tour-next">
                    <a onClick={this.closeTour} className="skipaction">Skip</a>
                    <a className="nextaction  btn btn-primary btn-xs" onClick={() => goTo(this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 1:currentStepTour)}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
                  </div>
                </div>
              </div>
            ),
          },
          
          {selector: '[data-tut="buildingcontrollerdesktop"]',
              content: ({ goTo }) => (
              <div className="tour-inner left-inner">
                <div class="bubble-container buildingcontroller-bubble">
              <div class="circle delay1"></div>
              <div class="circle delay2"></div>
              <div class="circle delay3"></div>
              <div class="circle delay4"></div>
            </div>      
              <div className="tour-top">
              <h6>Controls</h6>
              {
                this.props.const_var.loginSession == true
                ?
                  <p>View Frame only, Center align doors & windows, zoom in & out, rotate the building, check measurements etc.</p>
                :
                  <p>View Frame only, Center align doors & windows, zoom in & out, rotate the building, check measurements etc.</p>
                }
              </div>       
                <div className="tourfooter">
                  <div className="tour-count-present">{this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"?2:currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                  <div className="tour-next">
                    <a onClick={this.closeTour} className="skipaction">Skip</a>
                    <a className="nextaction btn btn-primary btn-xs" onClick={() => goTo(this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 3:currentStepTour)}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
                  </div>
                </div>
              </div>
            )
            },
    
            this.state.isSmallScreen == true && this.props.const_var.crmSetting.is_module_name!="inventory" && {
              selector: '[data-tut="twoddrawing"]',
              content: ({ goTo }) => (
                <div className="tour-inner bottom-inner">
                  <div className="bubble-container twoddrawing-bubble" style={{'left':`${this.props.const_var.crmSetting.is_loggedin==false ? '160px':''}`}}>
                    <div className="circle delay1"></div>
                    <div className="circle delay2"></div>
                    <div className="circle delay3"></div>
                    <div className="circle delay4"></div>
                  </div>
                  <div className="tour-top">
                    <h6>2D Layout</h6>
                    <p>Generate and preview the 2D layout of your custom-designed building.</p>
                  </div>
                  <div className="tourfooter">
                    <div className="tour-count-present">{currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                    <div className="tour-next">
                      <a onClick={this.closeTour} className="skipaction">Skip</a>
                      <a className="nextaction btn btn-primary btn-xs" onClick={() => { goTo(currentStepTour); }}>
                        <span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span>
                      </a>
                    </div>
                  </div>
                </div>
              ),
              position: "bottom",
            },
    
            {selector: '[data-tut="headpaneloption"]',
              content: ({ goTo }) => (
              <div className="tour-inner left-inner">
                <div class="bubble-container headpaneloption-bubble">
              <div class="circle delay1"></div>
              <div class="circle delay2"></div>
              <div class="circle delay3"></div>
              <div class="circle delay4"></div>
            </div>      
              <div className="tour-top">
              <h6> { this.props.const_var.loginSession == true ? 'Head Panel' : 'State & Price Summary'} </h6>
                { this.props.const_var.loginSession == true ? 
    
                <>
                  <p className={this.props.const_var.crmSetting.is_module_name!="inventory"?'d-none':''}>Locate the Selected State, Manufacturer, Building Size and Price Summary for Inventory.</p>
                <p className={this.props.const_var.crmSetting.is_module_name=="inventory"?'d-none':''}>View or modify selected State, Manufacturer, Building price (with summary) and the lead/customer</p>
                </>
                :
                  <p>Locate Selected State, Price Summary/Contact details for Quote </p>
              }
              
              </div>       
                <div className="tourfooter">
                  <div className="tour-count-present">{this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"?3:currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                  <div className="tour-next">
                    <a onClick={this.closeTour} className="skipaction">Skip</a>
                    {
                      this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"
                      ?
                      <a className="nextaction btn btn-primary btn-xs" onClick={() => goTo(this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 5 :currentStepTour)}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
                      :
                      <a className="nextaction btn btn-primary btn-xs" onClick={() => this.clickForSaveCompare()}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
                    }
                    <a style={{'position':'absolute','opacity':'0'}} className="nextaction btn btn-primary btn-xs gosavecompare" onClick={() => goTo(currentStepTour)}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
                  </div>
                </div>
              </div>
            ),
              position: "bottom",
    
            },
    
    
            this.state.isSmallScreen == true && this.props.const_var.crmSetting.is_module_name!="inventory" && {
              selector: '[data-tut="compare-data-tut"]',
              content: ({ goTo }) => (
                <div className="tour-inner bottom-inner">
                  <div className="bubble-container compare-data-tut-bubble" style={{'left':`${this.props.const_var.crmSetting.is_loggedin==false ? '160px':''}`}}>
                    <div className="circle delay1"></div>
                    <div className="circle delay2"></div>
                    <div className="circle delay3"></div>
                    <div className="circle delay4"></div>
                  </div>
                  <div className="tour-top">
                    <h6>Compare</h6>
                    {isCompareExsist && !hideCompareOption && !isCustomBuilding && !this.props.const_var.checkmoreCustomizeFlag 
                      ?
                      <p> Compare your building designs with other providers to get the best deal. </p>
                      :
                      <p> The compare feature is not provided by this manufacturer. Please contact a salesperson. </p>
                    }
                  </div>
                  <div className="tourfooter">
                    <div className="tour-count-present">{currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                    <div className="tour-next">
                      <a onClick={this.closeTour} className="skipaction">Skip</a>
                      <a className="nextaction btn btn-primary btn-xs" onClick={() => { goTo(currentStepTour); }}>
                        <span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span>
                      </a>
                    </div>
                  </div>
                </div>
              ),
              position: "bottom",
            } ,
    
            {selector: '[data-tut="leftpanelfooter"]',
              content: ({ goTo }) => (
              <div className="tour-inner left-inner">
                <div class='bubble-container leftpanelfooter-bubble'>
              <div class="circle delay1"></div>
              <div class="circle delay2"></div>
              <div class="circle delay3"></div>
              <div class="circle delay4"></div>
            </div>      
              <div className="tour-top">
    
              { this.props.const_var.user_type_for_comparision!="premium" && this.props.const_var.loginSession == true ? <>
    
                <h6>Save</h6>
                <p>Save design to create an order</p>
              </> : 
              <>
              <h6 className={this.props.const_var.crmSetting.is_module_name=="inventory"?'d-none':''}>Save and Share</h6>       
              <h6 className={this.props.const_var.crmSetting.is_module_name!="inventory"?'d-none':''}>Save</h6>       
                  { this.props.const_var.loginSession == true ? 
                  <>
                  <p className={this.props.const_var.crmSetting.is_module_name!="inventory"?'d-none':''}>Save design to create inventory</p>
                  <p className={this.props.const_var.crmSetting.is_module_name=="inventory"?'d-none':''}>Save design to order or compare prices across multiple manufacturers</p>
                  </>
                  :
                  <p>Save your building design to place an order and share it for final decision making.</p>
    
                }</> }
    
              
              </div>       
                <div className="tourfooter">
                  <div className="tour-count-present">{this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"?4:currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                  <div className="tour-next">
              
                    <a className="nextaction  btn btn-primary btn-xs" onClick={()=> {this.closeTour();this.props.getSelectedTab("buildingtypetab")}}><span className="text"></span>Done</a>
    
                  </div>
                </div>
              </div>
            ),
              position: "top",
    
            },
          ] 
      )
      
    :
    [
      {
        selector: '[data-tut="configoptions"]',
        content: ({ goTo }) => (
          <div className="tour-inner right-inner">
            <div class="bubble-container configoptions-bubble">
              <div class="circle delay1"></div>
              <div class="circle delay2"></div>
              <div class="circle delay3"></div>
              <div class="circle delay4"></div>
            </div>
            <div className="tour-top">
              <h6>Configuration Panel</h6>
              {this.props.const_var.loginSession === true ? (
                <p>Choose building style, size, colors, doors & windows, lean-tos, snow ratings and everything that’s practically possible. </p>
              ) : (
                <p>Choose building style, size, colors, doors & windows, lean-tos, snow ratings and everything that’s practically possible. </p>
              )}
            </div>
            <div className="tourfooter">
              <div className="tour-count-present">{currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 3 :desktoptourConfig.length}</div>
              <div className="tour-next">
                <a onClick={this.closeTour} className="skipaction">Skip</a>
                <a className="nextaction  btn btn-primary btn-xs" onClick={() => goTo(this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 1:currentStepTour)}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
              </div>
            </div>
          </div>
        ),
      },
      
      {selector: '[data-tut="buildingcontrollerdesktop"]',
          content: ({ goTo }) => (
          <div className="tour-inner left-inner">
            <div class="bubble-container buildingcontroller-bubble">
          <div class="circle delay1"></div>
          <div class="circle delay2"></div>
          <div class="circle delay3"></div>
          <div class="circle delay4"></div>
        </div>      
          <div className="tour-top">
          <h6>Controls</h6>
            {
              this.props.const_var.loginSession == true
              ?
                <p>View Frame only, Center align doors & windows, zoom in & out, rotate the building, check measurements etc.</p>
              :
                <p>View Frame only, Center align doors & windows, zoom in & out, rotate the building, check measurements etc.</p>
            }
          </div>       
            <div className="tourfooter">
              <div className="tour-count-present">{this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"?2:currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 3 :desktoptourConfig.length}</div>
              <div className="tour-next">
                <a onClick={this.closeTour} className="skipaction">Skip</a>
                <a className="nextaction btn btn-primary btn-xs" onClick={() => goTo(this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 3:currentStepTour)}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
              </div>
            </div>
          </div>
        )
        },

        this.state.isSmallScreen == true && this.props.const_var.crmSetting.is_module_name!="inventory" && {
          selector: '[data-tut="twoddrawing"]',
          content: ({ goTo }) => (
            <div className="tour-inner bottom-inner">
              <div className="bubble-container twoddrawing-bubble" style={{'left':`${this.props.const_var.crmSetting.is_loggedin==false ? '160px':''}`}}>
                <div className="circle delay1"></div>
                <div className="circle delay2"></div>
                <div className="circle delay3"></div>
                <div className="circle delay4"></div>
              </div>
              <div className="tour-top">
                <h6>2D Layout</h6>
                <p>Generate and preview the 2D layout of your custom-designed building.</p>
              </div>
              <div className="tourfooter">
                <div className="tour-count-present">{currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 3 :desktoptourConfig.length}</div>
                <div className="tour-next">
                  <a onClick={this.closeTour} className="skipaction">Skip</a>
                  <a className="nextaction btn btn-primary btn-xs" onClick={() => { goTo(currentStepTour); }}>
                    <span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span>
                  </a>
                </div>
              </div>
            </div>
          ),
          position: "bottom",
        } ,

        {selector: '[data-tut="headpaneloption"]',
          content: ({ goTo }) => (
          <div className="tour-inner left-inner">
            <div class="bubble-container headpaneloption-bubble">
          <div class="circle delay1"></div>
          <div class="circle delay2"></div>
          <div class="circle delay3"></div>
          <div class="circle delay4"></div>
        </div>      
          <div className="tour-top">
          <h6> { this.props.const_var.loginSession == true ? 'Head Panel' : 'State & Price Summary'} </h6>
            { this.props.const_var.loginSession == true ? 

            <>
              <p className={this.props.const_var.crmSetting.is_module_name!="inventory"?'d-none':''}>Locate the Selected State, Manufacturer, Building Size and Price Summary for Inventory.</p>
            <p className={this.props.const_var.crmSetting.is_module_name=="inventory"?'d-none':''}>View or modify selected State, Manufacturer, Building price (with summary) and the lead/customer</p>
            </>
            :
              <p>Locate Selected State, Price Summary/Contact details for Quote </p>
          }
          
          </div>       
            <div className="tourfooter">
              <div className="tour-count-present">{this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory" ? 3 : currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 3 :desktoptourConfig.length}</div>
              <div className="tour-next">
                <a onClick={this.closeTour} className="skipaction">Skip</a>
                {
                   this.state.isSmallScreen == true && this.props.const_var.crmSetting.is_module_name!="inventory"
                   ?
                    <a className="nextaction btn btn-primary btn-xs" onClick={() => { goTo(currentStepTour); }}>
                      <span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span>
                    </a>
                  :
                    <a className="nextaction  btn btn-primary btn-xs" onClick={()=> {this.closeTour();this.props.getSelectedTab("buildingtypetab")}}><span className="text"></span>Done</a>
                }
              </div>
            </div>
          </div>
        ),
          position: "bottom",

        },

        this.state.isSmallScreen == true && this.props.const_var.crmSetting.is_module_name!="inventory" && {
          selector: '[data-tut="compare-data-tut"]',
          content: ({ goTo }) => (
            <div className="tour-inner bottom-inner">
              <div className="bubble-container compare-data-tut-bubble" style={{'left':`${this.props.const_var.crmSetting.is_loggedin==false ? '160px':''}`}}>
                <div className="circle delay1"></div>
                <div className="circle delay2"></div>
                <div className="circle delay3"></div>
                <div className="circle delay4"></div>
              </div>
              <div className="tour-top">
                <h6>Compare</h6>
                {
                  isCompareExsist && !hideCompareOption && !isCustomBuilding && !this.props.const_var.checkmoreCustomizeFlag 
                  ?
                  <p> Compare your building designs with other providers to get the best deal. </p>
                  :
                  <p> The compare feature is not provided by this manufacturer. Please contact a salesperson. </p>
                }
              </div>
              <div className="tourfooter">
                <div className="tour-count-present">{this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"?4:currentStepTour} of {this.state.isSmallScreen!=true || this.props.const_var.crmSetting.is_module_name=="inventory"? 4 :desktoptourConfig.length}</div>
                <div className="tour-next">
            
                  <a className="nextaction  btn btn-primary btn-xs" onClick={()=> {this.closeTour();this.props.getSelectedTab("buildingtypetab")}}><span className="text"></span>Done</a>

                </div>
              </div>
            </div>
          ),
          position: "bottom",
        } ,
      ]
;
 


const devicetourConfig = this.props.const_var.crmSetting != undefined && this.props.const_var.crmSetting.is_show_cta != false ?
   [
    {selector: '[data-tut="Designyourbuilding"]',
    content: ({ goTo }) => (
      <div className="tour-inner right-inner">
       <div class="bubble-container Designyourbuilding-bubble">
      <div class="circle delay1"></div>
      <div class="circle delay2"></div>
      <div class="circle delay3"></div>
      <div class="circle delay4"></div>
    </div>
      
       <div className="tour-top">
      <h6>Design</h6>   

        <p>Choose building style, size, colors, doors & windows, lean-tos, snow ratings and everything that’s practically possible.</p>

         
      </div>       
        <div className="tourfooter">
          <div className="tour-count-present">{currentStepTour} of {devicetourConfig.length}</div>
          <div className="tour-next">
            <a onClick={this.closeTour} className="skipaction">Skip</a>
            <a className="nextaction  btn btn-primary btn-xs" onClick={() => goTo(currentStepTour)}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
          </div>
        </div>
      </div>
    )
    },

       {selector: '[data-tut="buildingcontrollerdevice"]',
       content: ({ goTo }) => (
      <div className="tour-inner bottom-inner">
       <div class="bubble-container buildingcontrollerdevice-bubble">
      <div class="circle delay1"></div>
      <div class="circle delay2"></div>
      <div class="circle delay3"></div>
      <div class="circle delay4"></div>
    </div>
      <div className="tour-top">
      <h6>Controls </h6>
        {
          this.props.const_var.loginSession == true
          ?
            <p>View building dimensions, Interior Frame, and add background.</p>
          :
            <p>View building dimensions, Interior Frame, and add background.</p>
        }
        
      </div>       
        <div className="tourfooter">
          <div className="tour-count-present">{currentStepTour} of {devicetourConfig.length}</div>
          <div className="tour-next">  
               <a onClick={this.closeTour} className="skipaction">Skip</a> 
          <a className="nextaction btn btn-primary btn-xs" onClick={() => {goTo(currentStepTour);}}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>      
          </div>
        </div>
      </div>
    ),

       position: "bottom",


    },

    {selector: '[data-tut="headpaneldevice"]',
      content: ({ goTo }) => (
       <div className="tour-inner left-inner">
        <div class="bubble-container headpaneldevice-bubble">
      <div class="circle delay1"></div>
      <div class="circle delay2"></div>
      <div class="circle delay3"></div>
      <div class="circle delay4"></div>
    </div>      
      <div className="tour-top">
      <h6>{ this.props.const_var.loginSession == true ? 'Summary':'Contact & Summary'}</h6>
        <p>{ this.props.const_var.loginSession == true ? 'Review the building details and price.':'Call or Email us to review the building details and price.' }</p>
      </div>       
        <div className="tourfooter">
          <div className="tour-count-present">{currentStepTour} of {devicetourConfig.length}</div>
          <div className="tour-next">
            <a onClick={this.closeTour} className="skipaction">Skip</a>
            <a className="nextaction btn btn-primary btn-xs" onClick={(key) => this.clickthumb('gothumbpreview')}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>  

              <a style={{'position':'absolute','opacity':'0'}} className="nextaction btn btn-primary btn-xs clickforthumbpreview" onClick={() => {goTo(currentStepTour);}}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
          </div>
        </div>
      </div>
    )
    },

    {selector: '[data-tut="Thumbnailtour"]',
      content: ({ goTo }) => (
       <div className="tour-inner left-inner">
        <div class="bubble-container thumbnailtour-bubble">
      <div class="circle delay1"></div>
      <div class="circle delay2"></div>
      <div class="circle delay3"></div>
      <div class="circle delay4"></div>
    </div>      
      <div className="tour-top">
      <h6>Thumbnail</h6>
       <p>Preview live changes – Tap on building to see full view. </p>
       
      </div>       
        <div className="tourfooter">
          <div className="tour-count-present">{currentStepTour} of {devicetourConfig.length}</div>
          <div className="tour-next">
            <a onClick={()=> {this.closeTour();this.clickthumb('getfullbuilding')}} className="skipaction">Skip</a>
            <a className="nextaction btn btn-primary btn-xs" onClick={() => {goTo(currentStepTour);this.props.getSelectedTab("buildsizes")}}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
          </div>
        </div>
      </div>
    ),
       position: "bottom",

    },

    {selector: '[data-tut="VieworSaveQuote"]',
      content: ({ goTo }) => (
       <div className="tour-inner left-inner">
        <div class="bubble-container vieworSaveQuote-bubble">
      <div class="circle delay1"></div>
      <div class="circle delay2"></div>
      <div class="circle delay3"></div>
      <div class="circle delay4"></div>
    </div>   

     
            <div className="tour-top ipad-portrait-only">
      { this.props.const_var.user_type_for_comparision!="premium"  ? <>

        <h6>Save</h6>
        {
           this.props.const_var.crmSetting.order_now == true 
           ?
           <p>Save design to create an order.</p>
           :
           <p>Save design to create an order.</p>
        }
       </> : 
      <>
      <h6 className={this.props.const_var.crmSetting.is_module_name=="inventory"?'d-none':''}>Save and Share</h6>       
      <h6 className={this.props.const_var.crmSetting.is_module_name!="inventory"?'d-none':''}>Save</h6>       
           { this.props.const_var.loginSession == true ? 
           <>
           <p className={this.props.const_var.crmSetting.is_module_name!="inventory"?'d-none':''}>Reset or Save design to create inventory </p>
           <p className={this.props.const_var.crmSetting.is_module_name=="inventory"?'d-none':''}>Save your building design to place an order and share it for final decision making.</p>
           </>
           :
           <p>Save your building design to place an order and share it for final decision making.</p>

         }</> }

      
      </div> 
       <div className="tour-top device-only-below-ipad">
      <h6 className={this.props.const_var.crmSetting.is_module_name=="inventory"?'d-none':''}>Save Quote</h6>
      <h6 className={this.props.const_var.crmSetting.is_module_name=="inventory"?"":"d-none"}>Save</h6>
       <p className={this.props.const_var.crmSetting.is_module_name=="inventory"?'d-none':''}>Save your building design to order or download the Quote for the final decision making.</p>   
       <p className={this.props.const_var.crmSetting.is_module_name=="inventory"?"":"d-none"}>Reset or Save design to create inventory</p>     
      </div> 
     
           
        <div className="tourfooter">
          <div className="tour-count-present">{currentStepTour} of {devicetourConfig.length}</div>
          <div className="tour-next">
            {/*<a onClick={this.closeTour} className="skipaction">Skip</a>*/}
             <a className="nextaction  btn btn-primary btn-xs" onClick={()=>{this.closeTour();this.clickthumb('getfullbuilding')}}><span className="text"></span>Done</a>

            {/*<a className="nextaction btn btn-primary btn-xs" onClick={() => {goTo(currentStepTour);this.props.getSelectedTab("extraoptions")}}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>*/}
          </div>
        </div>
      </div>
    ),
       position: "bottom",

    },
    // {selector: '[data-tut="GenerateQuote"]',
    //   content: ({ goTo }) => (
    //    <div className="tour-inner left-inner">
    //     <div class="bubble-container leftpanelfooter-bubble">
    //   <div class="circle delay1"></div>
    //   <div class="circle delay2"></div>
    //   <div class="circle delay3"></div>
    //   <div class="circle delay4"></div>
    // </div>      
    //   <div className="tour-top">
    //   <h6>Generate Quote</h6>       
    //       <p>Design your building step by step. When you're done, just hit 'Generate Quote' under the 'Options' tab to get your quote. </p>
    //   </div>       
    //     <div className="tourfooter">
    //       <div className="tour-count-present">{currentStepTour} of {devicetourConfig.length}</div>
    //       <div className="tour-next">
       
    //          <a className="nextaction  btn btn-primary btn-xs" onClick={this.closeTour}><span className="text"></span>Done</a>

    //       </div>
    //     </div>
    //   </div>
    // ),
    //    position: "top",

    // },  
  ]
  :
  [
    {selector: '[data-tut="Designyourbuilding"]',
    content: ({ goTo }) => (
      <div className="tour-inner right-inner">
       <div class="bubble-container Designyourbuilding-bubble">
      <div class="circle delay1"></div>
      <div class="circle delay2"></div>
      <div class="circle delay3"></div>
      <div class="circle delay4"></div>
    </div>
      
       <div className="tour-top">
      <h6>Design</h6>   

        <p>Choose building style, size, colors, doors & windows, lean-tos, snow ratings and everything that’s practically possible.</p>

         
      </div>       
        <div className="tourfooter">
          <div className="tour-count-present">{currentStepTour} of {devicetourConfig.length}</div>
          <div className="tour-next">
            <a onClick={this.closeTour} className="skipaction">Skip</a>
            <a className="nextaction  btn btn-primary btn-xs" onClick={() => goTo(currentStepTour)}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
          </div>
        </div>
      </div>
    )
    },

       {selector: '[data-tut="buildingcontrollerdevice"]',
       content: ({ goTo }) => (
      <div className="tour-inner bottom-inner">
       <div class="bubble-container buildingcontrollerdevice-bubble">
      <div class="circle delay1"></div>
      <div class="circle delay2"></div>
      <div class="circle delay3"></div>
      <div class="circle delay4"></div>
    </div>
      <div className="tour-top">
      <h6>Controls </h6>
        {
          this.props.const_var.loginSession == true
          ?
            <p>View building dimensions, Interior Frame, and add background.</p>
          :
            <p>View building dimensions, Interior Frame, and add background.</p>
        }
      </div>       
        <div className="tourfooter">
          <div className="tour-count-present">{currentStepTour} of {devicetourConfig.length}</div>
          <div className="tour-next">  
               <a onClick={this.closeTour} className="skipaction">Skip</a> 
          <a className="nextaction btn btn-primary btn-xs" onClick={() => {goTo(currentStepTour);}}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>      
          </div>
        </div>
      </div>
    ),

       position: "bottom",


    },

    {selector: '[data-tut="headpaneldevice"]',
      content: ({ goTo }) => (
       <div className="tour-inner left-inner">
        <div class="bubble-container headpaneldevice-bubble">
      <div class="circle delay1"></div>
      <div class="circle delay2"></div>
      <div class="circle delay3"></div>
      <div class="circle delay4"></div>
    </div>      
      <div className="tour-top">
      <h6>{ this.props.const_var.loginSession == true ? 'Summary':'Contact & Summary'}</h6>
        <p>{ this.props.const_var.loginSession == true ? 'Review the building details and price.':'Call or Email us to review the building details and price.' }</p>
      </div>       
        <div className="tourfooter">
          <div className="tour-count-present">{currentStepTour} of {devicetourConfig.length}</div>
          <div className="tour-next">
            <a onClick={this.closeTour} className="skipaction">Skip</a>
            <a className="nextaction btn btn-primary btn-xs" onClick={(key) => this.clickthumb('gothumbpreview')}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>  

              <a style={{'position':'absolute','opacity':'0'}} className="nextaction btn btn-primary btn-xs clickforthumbpreview" onClick={() => {goTo(currentStepTour);}}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>
          </div>
        </div>
      </div>
    )
    },

    {selector: '[data-tut="Thumbnailtour"]',
      content: ({ goTo }) => (
       <div className="tour-inner left-inner">
        <div class="bubble-container thumbnailtour-bubble">
      <div class="circle delay1"></div>
      <div class="circle delay2"></div>
      <div class="circle delay3"></div>
      <div class="circle delay4"></div>
    </div>      
      <div className="tour-top">
      <h6>Thumbnail</h6>
       <p>Preview live changes – Tap on building to see full view. </p>
       
      </div>       
        <div className="tourfooter">
          <div className="tour-count-present">{currentStepTour} of {devicetourConfig.length}</div>
          <div className="tour-next">
            {/*<a onClick={this.closeTour} className="skipaction">Skip</a>*/}
             <a className="nextaction  btn btn-primary btn-xs" onClick={()=>{this.closeTour();this.clickthumb('getfullbuilding')}}><span className="text"></span>Done</a>

            {/*<a className="nextaction btn btn-primary btn-xs" onClick={() => {goTo(currentStepTour);this.props.getSelectedTab("extraoptions")}}><span className="text"></span>Next<span className="icon icon-arrow-down custom-cls-arrow"></span></a>*/}
          </div>
        </div>
      </div>
    ),
       position: "bottom",

    },  
  ]


    return (
      <>
        <Tour
        showButtons={false}
        highlightedMaskClassName="maskcustom"
        disableInteraction="true"
        startAt={Number(startTourNumber)}
        getCurrentStep={(curr) => this.currentStepget(curr)}
        steps={this.state.isDevice==true ? devicetourConfig:  desktoptourConfig}
        className="usertourguide"
        isOpen={isOpenUserTour}
        prevStep={this.handlePrevStep}
        nextStep={this.handleNextStep}
        onRequestClose={this.closeTour} />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
...state.reducer
});

const mapDispatchToProps = {
UsertourAction,
getSelectedTab,
handleMobileDraw
}

export default connect(
mapStateToProps,
mapDispatchToProps
)
(UserTour)

